export default "__VITE_PUBLIC_ASSET__9e364834__"